import { IoMdCloseCircleOutline } from "react-icons/io";
import { shortenFileName } from "../../../../../../../../utils/helper";

const UploadedFile = ({ uploadedFiles, removeFile, fileUploading }) => {
  return (
    <div className="file-preview-container">
      {fileUploading && <div className="upload-file-loader">
        <div className="upload-file-spinner"></div>
      </div>}
      {uploadedFiles.map((file) => (
        <div key={file.id} className="file-preview">
          {file.type === 'image' && (
            <img src={file.previewURL} alt={file.name} className="file-preview-image" />
          )}
          {file.type === 'audio' && (
            <a href={file.previewURL} target="_blank" className="file-preview-audio">
              <img src="/images/audio.svg" alt={file.name} className="file-preview-image" />
              <span spellcheck="false">${shortenFileName(file.name, 15, 10)}</span>
            </a>
          )}
          {file.type !== 'image' && file.type !== 'audio' && (
            <a
              href={file.previewURL}
              target="_blank"
              rel="noopener noreferrer"
              className="file-preview-link"
            >
              <span>${shortenFileName(file.name, 15, 10)}</span>
            </a>
          )}
          <button
            className="file-preview-remove"
            onClick={() => removeFile(file.id)}
          >
            <IoMdCloseCircleOutline size={20} color={file.type == "image" ? "#000000" : "#ffffff"} />
          </button>
        </div>
      ))}
    </div>
  )
}

export default UploadedFile